import {
  Component,
  Input,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
  Renderer2,
  OnChanges,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import * as FileSaver from "file-saver";
import {
  Table,
  TableFilterEvent,
  TableLazyLoadEvent,
  TableModule,
} from "primeng/table";
import { debounceTime, Subject } from "rxjs";
import { InventoryPurchaseService } from "../../../core/services/inventory-purchase.service";
import { GetInventoryPurchase } from "../../../core/models/inventoryPurchases/getInventoryPurchasesDto";
import { CommonModule, DatePipe } from "@angular/common";
import { GenericFilterRequestDto } from "../../../core/models/generic-filter-request.dto";
import { GenericRequestDto } from "../../../core/models/generic-request.dto";
import { GenericSortRequestDto } from "../../../core/models/generic-sort-request.dto";
import { DateFilter } from "../../../core/models/shared/dateFilter";
import { ClientsListingService } from "../../../core/services/clients-listing.service";
import { SharedService } from "../../../core/services/shared.service";
import { UserRole } from "../../../shared/enums/userRoles.enum";
import { UserManagementService } from "../../../core/services/user-management.service";
import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";
import { DateFilterComponent } from "../../../shared/components/date-filter/date-filter.component";
import { FormsModule } from "@angular/forms";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { InventoryPurchaseSummaryComponent } from "../inventory-purchase-summary/inventory-purchase-summary.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";
import { FilterMetadata } from "primeng/api";

@UntilDestroy()
@Component({
  selector: "jni-inventory-purchase-listing",
  templateUrl: "./inventory-purchase-listing.component.html",
  styleUrls: ["./inventory-purchase-listing.component.scss"],
  imports: [
    CommonModule,
    TableModule,
    CheckboxModule,
    DateFilterComponent,
    FormsModule,
    ModalStackerComponent,
    InventoryPurchaseSummaryComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    SpinnerComponent,
  ],
})
export class InventoryPurchaseListingComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @Input() ponumber!: string;
  @Output() scrollHiddenStatus = new EventEmitter();

  lazyLoadEvent: TableLazyLoadEvent = {
    filters: {},
    first: 0,
    globalFilter: null,
    multiSortMeta: undefined,
    rows: 20,
    sortField: undefined,
    sortOrder: 1,
  };

  inventoryPurchLists: GetInventoryPurchase[] = [];
  filteredDataInventoryPurchLists: GetInventoryPurchase[] = [];
  selectedSamplePO: GetInventoryPurchase[] = [];
  showLoader = false;
  filterDebounceTime = 1000;
  filterTextChanged: Subject<
    Event | DateFilter | CheckboxChangeEvent | GetInventoryPurchase[] | null
  > = new Subject<
    Event | DateFilter | CheckboxChangeEvent | GetInventoryPurchase[] | null
  >();
  samplePOSummaryDisplayModal = false;
  totalRecords = 0;
  defaultTake = 50;
  samplePOIdFromModal = "";
  inventoryPurchListModalStatus = false;

  excelRequest: GenericRequestDto = {} as GenericRequestDto;
  filterMode = "server";
  createdDateFieldName = "createdDate";
  inHandDateFilter = {} as DateFilter;
  createdDateFilter = {} as DateFilter;
  inventoryPurchaseFilter = true;
  // childPoFilter = false;
  userRole = 0;
  enumUserRole = UserRole;

  inHandFieldName = "inHandsDate";

  @ViewChild("dt") table!: Table;
  constructor(
    private _router: Router,
    private _inventoryPurchListService: InventoryPurchaseService,
    public _clientsListingService: ClientsListingService,
    private renderer: Renderer2,
    private _sharedService: SharedService,
    private _loginService: UserManagementService,
    public datepipe: DatePipe
  ) {
    //this.ponumber = this._router.getCurrentNavigation()?.extras.state;
    const state = this._router.getCurrentNavigation()?.extras.state;
    if (state) {
      this.ponumber = state["ponumber"];
    }
    // this.getAllinventoryPurchListData(this.lazyLoadEvent);
  }
  ngOnInit(): void {
    this.getUserProfile();
    this.filterTextChanged
      .pipe(debounceTime(this.filterDebounceTime))
      .subscribe(() => {
        this.getAllinventoryPurchListData(this.lazyLoadEvent);
      });
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe(res => {
        this.userRole = res.data.userRoleId;
      });
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  ngOnChanges() {
    if (this.ponumber) {
      this.inventoryPurchListModalStatus = true;
    }
  }

  ngAfterViewInit() {
    if (this.ponumber) {
      if (this.table) {
        this.table.filters["purchaseOrderNumber"] = {
          value: this.ponumber,
          matchMode: "startsWith",
        };
      }
    }
  }

  viewAfterInIt() {
    if (this.ponumber) {
      if (this.table) {
        this.table.filters["purchaseOrderNumber"] = {
          value: this.ponumber,
          matchMode: "startsWith",
        };
      }
    }
  }

  getCurrentSamplePo(accountnumber: string) {
    if (accountnumber) {
      this.samplePOIdFromModal = accountnumber;
      this.samplePOSummaryDisplayModal = true;
    }
    //this._router.navigate(['/samplepo/samplepo-summary/' + accountnumber]);
  }

  onSamplePORedirection() {
    this._router.navigate(["inventory-purchase/inventory-purchase-header"]);
  }

  getAllinventoryPurchListData(event: TableLazyLoadEvent) {
    this.lazyLoadEvent = event;
    this.showLoader = true;
    const eventFilterArray = Object.keys(event.filters ?? {});
    const filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
      const tableFilter = event?.filters?.[x] as FilterMetadata;
      return {
        columnName: x ?? "",
        matchMode: tableFilter.matchMode ?? "",
        tableName: "",
        value: tableFilter.value ?? "",
      } as GenericFilterRequestDto;
    });

    const sortArray: GenericSortRequestDto[] =
      event.multiSortMeta?.map(x => {
        return {
          ...x,
        } as GenericSortRequestDto;
      }) ?? [];

    filter.forEach(x => {
      if (x.columnName == "purchaseOrderNumber") {
        x.columnName = "PurchaseOrderNumberD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "purchaseOrderStatus") {
        x.columnName = "PurchaseOrderStatusD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "jobName") {
        x.columnName = "JobNameD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "storeName") {
        x.columnName = "StoreD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "clientAccountName") {
        x.columnName = "OrganizationNameD365";
        x.tableName = "Client";
      }
      if (x.columnName == "shippingMethod") {
        x.columnName = "DeliveryModeIdD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "currency") {
        x.columnName = "CurrencyCodeD365";
        x.tableName = "PurchaseOrderHeader";
      }
      // if (x.columnName == 'childPo') {
      //   x.columnName = 'ChildPoD365';
      //   x.tableName = 'PurchaseOrderHeader';
      // }
      if (x.columnName == "masterPo") {
        x.columnName = "MasterPoD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "subTotal") {
        x.columnName = "TotalAmountD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "arrivalStatus") {
        x.columnName = "ArrivalStatusD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "jniInventoryPurchase") {
        x.columnName = "InventoryPurchaseD365";
        x.tableName = "PurchaseOrderHeader";
        x.value = this.inventoryPurchaseFilter ? "true" : "false";
      }
      // if (x.columnName == 'ChildPoD365') {
      //   x.columnName = 'ChildPoD365';
      //   x.tableName = 'PurchaseOrderHeader';
      //   x.value = this.childPoFilter ? 'true' : 'false';
      // }

      const inHandDate =
        this.convertDateFormat(this.inHandDateFilter.startDate ?? "") +
        "|" +
        this.convertDateFormat(this.inHandDateFilter.endDate ?? "");
      if (x.columnName == this.inHandFieldName) {
        x.columnName = "ExpectedStoreReceiptDateD365";
        x.tableName = "PurchaseOrderHeader";
        x.value = inHandDate;
        x.matchMode = this.inHandDateFilter.selectedMatchMode;
      }

      const createdDate =
        this.convertDateFormat(this.createdDateFilter.startDate ?? "") +
        "|" +
        this.convertDateFormat(this.createdDateFilter.endDate ?? "");
      if (x.columnName == this.createdDateFieldName) {
        x.columnName = "CreatedDate";
        x.tableName = "PurchaseOrderHeader";
        x.value = createdDate;
        x.matchMode = this.createdDateFilter.selectedMatchMode;
      }
    });
    const request: GenericRequestDto = {
      skip: event.first ?? 0,
      take: event.rows ?? this.defaultTake,
      filters: filter,
      sort: sortArray,
    };

    //filter;
    this.excelRequest = request;
    //service to be written
    this._inventoryPurchListService
      .getAllInventoryPO(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showLoader = false;
          this.inventoryPurchLists = res.data;
          this.filteredDataInventoryPurchLists = this.inventoryPurchLists;
          this.totalRecords = res.totalRecords ?? 0;
        },
      });
    //   this.inventoryPurchLists = [{
    // purchaseOrderNumber: "20347433",
    // inventoryPurchase: "Yes",
    // purchaseOrderStatus: "Active",
    // currency: "USD",
    // shippingMethod: "UPS Method",
    // deliveryTerms: "",
    // childPO: "Yes",
    // masterPO: "Yes",
    //   }]
    // this.filteredDataInventoryPurchLists = this.inventoryPurchLists;
    // this.totalRecords = 1;
  }

  convertDateFormat(date: string) {
    return this.datepipe.transform(date, "yyyy-MM-dd") ?? "";
  }

  exportExcel() {
    this.showLoader = true;
    this.exportExcelForFilterData(this.inventoryPurchLists);
    this.showLoader = false;
  }

  // exportExcelAll() {
  //   this.showLoader = true;

  // this._inventoryPurchListService
  //   .getAllSamplePOExcel(this.excelRequest)
  //   .pipe(untilDestroyed(this))
  //   .subscribe({
  //     next: (res: any) => {
  //       this.showLoader = false;
  //       this.downloadFile(res);
  //     },
  //     error: (err) => {
  //       this.showLoader = false;
  //     }
  //   });
  //}

  // downloadFile(data: any) {
  //   const file = new Blob([data], {
  //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  //   });
  //   saveAs(file, `SamplePOList_export_${new Date().getTime()}.xlsx`);
  // }

  exportExcelForFilterData(filterclientlist: GetInventoryPurchase[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Purchase Order #"]: datum.purchaseOrderNumber
          ?.toLowerCase()
          ?.includes("temp")
          ? ""
          : datum.purchaseOrderNumber,
        ["Arrival Status"]: datum.arrivalStatus,
        ["Store Name"]: datum.storeName,
        ["Client Account Name"]: datum.clientAccName,
        ["Job Name"]: datum.jobName,
        ["Subtotal"]: datum.subtotal,
        ["Currency"]: datum.currency,
        ["GP %"]: datum.gpPercentage,
        ["In Hands Date"]: new Date(datum.inHandsDate ?? ""),
        ["Shipping Method"]: datum.shippingMethod,
        ["Inventory Purchases"]: datum.inventoryPurchase,
        ["Child PO"]: datum.childPo,
      };
    });
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "InvPurchaseList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  checkboxSelection() {
    if (this.selectedSamplePO.length > 1 || this.selectedSamplePO.length == 0) {
      this._clientsListingService.setAttachmentState(true);
    } else {
      this._clientsListingService.setAttachmentState(false);
    }
  }

  onFilterInput(
    $event:
      | Event
      | DateFilter
      | CheckboxChangeEvent
      | GetInventoryPurchase[]
      | null,
    value = ""
  ) {
    if (value === "clear") {
      this.clearFilter();
    }
    if ($event && typeof $event === "object" && "startDate" in $event) {
      const dateEvent = $event as DateFilter;
      if (dateEvent.startDate) {
        if (dateEvent.columnName === "inHandsDate") {
          this.inHandDateFilter = dateEvent;
        } else if (dateEvent.columnName === "createdDate") {
          this.createdDateFilter = dateEvent;
        }
      }
    }

    this.filterTextChanged.next($event);
  }

  closeModalFromSamplePOSummary() {
    this.samplePOSummaryDisplayModal = false;
  }

  closeModalFromSamplePOSummaryRefresh() {
    this.samplePOSummaryDisplayModal = false;
    this.selectedSamplePO = [];
    this.getAllinventoryPurchListData(this.lazyLoadEvent);
  }

  addScollHiddenClass() {
    if (this.inventoryPurchListModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    } else {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  clearFilter() {
    this.inHandDateFilter = {} as DateFilter;
    this.createdDateFilter = {} as DateFilter;
  }

  onFilter(event: TableFilterEvent) {
    if (
      Object.keys(event.filters!).length !== 0 &&
      event.filteredValue?.length !== 0
    ) {
      this.filteredDataInventoryPurchLists = event.filteredValue;
    } else {
      // this.filteredDataSamplePOLists = this.inventoryPurchLists;
    }
  }
}
